<template>
  <fragment>
    <AppBody
      title="Relatórios Sintéticos"
      :subtitle="$t('reports.nf-consumer.title')"
      :info="true"
      :infoMessage="$t('reports.nf-consumer.info')"
      :actions="actions"
      :primaryLoading="exportCSVLoading"
      :secondaryLoading="exportPDFLoading"
      disableDivider
    >
      <CardModule untitle>
        <ExpansionPanelFilters>
          <v-form
            ref="form"
            @submit.prevent="filterFinalConsumerNF"
            class="search-forms"
          >
            <v-row>
              <v-col cols="12" md="3" sm="4">
                <date-time-picker
                  :label="$t('reports.initial-date')"
                  @formatted-date="handleInitDateTime"
                ></date-time-picker>
              </v-col>

              <v-col cols="12" md="3" sm="4">
                <date-time-picker
                  :label="$t('reports.final-date')"
                  @formatted-date="handleEndDateTime"
                ></date-time-picker>
              </v-col>

              <v-col class="d-flex justify-end">
                <BaseButton
                  type="submit"
                  :loading="finalConsumerNFLoading"
                  variant="filter"
                >
                  {{ $t("reports.filter") }}
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </ExpansionPanelFilters>

        <v-data-table
          class="rounded-lg"
          :no-data-text="$t('reports.no-info-found')"
          :loading-text="$t('reports.loading-info')"
          mobile-breakpoint="0"
          :items="allFinalConsumerNF.info"
          :loading="finalConsumerNFLoading"
          :headers="headers"
          :items-per-page="10"
          :header-props="{
            class: 'rounded-t-lg',
            color: $config.dados.corinputs,
          }"
          :footer-props="{
            class: 'rounded-b-lg',
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: $t('reports.nf-consumer.consumer-per-page'),
          }"
          :custom-sort="$relatorios_sinteticos.customSort"
        >
          <template v-slot:item.nome="{ item }">
            {{ item.nome }}
          </template>
          <template v-slot:item.juros="{ item }">
            {{ item.juros | moeda }}
          </template>
          <template v-slot:item.taxa_conveniencia="{ item }">
            {{ item.taxa_conveniencia | moeda }}
          </template>
          <template v-slot:item.taxa_processamento="{ item }">
            {{ item.taxa_processamento | moeda }}
          </template>
          <template v-slot:item.total_consumidor="{ item }">
            {{ item.total_consumidor | moeda }}
          </template>

          <template
            v-for="(totais, index) in allFinalConsumerNF.totals"
            v-slot:body.append
          >
            <tr :key="index" class="text-end font-weight-bold total-row">
              <td class="text-start" colspan="8">Total</td>
              <td>{{ totais.total_consumidor | moeda }}</td>
            </tr>
          </template>
        </v-data-table>
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import dayjs from "dayjs";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import CardModule from "@/components/cards/CardModule.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import AppBody from "@/layouts/components/AppBody.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";
export default {
  name: "ConsumerFiscalNote",
  metaInfo() {
    const title = this.$t("reports.nf-consumer.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  components: {
    CardModule,
    DateTimePicker,
    BaseButton,
    AppBody,
    ExpansionPanelFilters,
  },
  data() {
    return {
      filter: {
        initDateTime: "",
        endDateTime: "",
      },
      actions: [
        {
          id: "CSV",
          name: "",
          icon: "mdi-microsoft-excel",
          action: () => this.exportCSV(),
        },
        {
          id: "PDF",
          name: "",
          icon: "mdi-file-pdf-box",
          action: () => this.exportPDF(),
        },
      ],
      dayjs: dayjs,
      activePicker: null,
      activePicker2: null,
      menu: false,
      menu2: false,
      date: null,
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "intervalDates",
      "exportCSVLoading",
      "exportPDFLoading",
      "allFinalConsumerNF",
      "finalConsumerNFLoading",
    ]),
    headers() {
      return [
        {
          text: this.$t("reports.nf-consumer.consumer-name"),
          align: "start",
          value: "nome",
          width: 200,
        },
        {
          text: "CPF",
          align: "start",
          value: "cpf",
          width: 150,
        },
        {
          text: "CNPJ",
          align: "start",
          value: "cnpj",
          width: 200,
        },
        {
          text: this.$t("reports.order"),
          align: "start",
          value: "pedido",
          width: 200,
        },
        {
          text: this.$t("reports.nf-consumer.installment"),
          align: "end",
          value: "parcela",
          width: 150,
        },
        {
          text: this.$t("reports.nf-consumer.installment-fees"),
          align: "end",
          value: "juros",
          width: 130,
        },
        {
          text: this.$t("reports.nf-consumer.installment-convenience-fee"),
          align: "end",
          value: "taxa_conveniencia",
          width: 240,
        },
        {
          text: this.$t("reports.nf-consumer.installment-processing-fee"),
          align: "end",
          value: "taxa_processamento",
          width: 240,
        },
        {
          text: this.$t("reports.nf-consumer.total-consumer"),
          align: "end",
          value: "total_consumidor",
          width: 160,
        },
      ];
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
  },
  methods: {
    ...mapActions([
      "fetchFinalConsumerNF",
      "exportFinalConsumerNFCSV",
      "exportFinalConsumerNFPDF",
    ]),
    ...mapMutations(["setFinalConsumerNFLoading"]),
    filterFinalConsumerNF() {
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_liberacao_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_liberacao_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
      });

      this.fetchFinalConsumerNF(filter);
    },
    exportCSV() {
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_liberacao_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_liberacao_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
      });

      this.exportFinalConsumerNFCSV(filter);
    },
    exportPDF() {
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_liberacao_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_liberacao_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
      });

      this.exportFinalConsumerNFPDF(filter);
    },
    handleInitDateTime(formatteddatetime) {
      this.filter.initDateTime = formatteddatetime;
    },
    handleEndDateTime(formatteddatetime) {
      this.filter.endDateTime = formatteddatetime;
    },
  },
  destroyed() {
    this.$relatorios_sinteticos.limpaFiltrosConsumidor();
  },
  beforeMount() {
    this.fetchFinalConsumerNF({
      producerId: this.storeSequencial,
    });
  },
};
</script>
<style scoped>
.info-tool {
  border-radius: 50px;
  margin-left: 5.625rem !important;
  cursor: pointer;
}
</style>
